export const API_GET_ALL_CHATS = '/api/chats'
